import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-crown-target',
  templateUrl: './crown-target.component.html',
  styleUrls: ['./crown-target.component.scss']
})
export class CrownTargetComponent implements OnInit {

  @Output() target: EventEmitter<boolean> = new EventEmitter;
  targetUserList: any = []
  campaignDetail: any
  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  page = 1;
  getPaginationCount;
  formGroup

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,


  ) { }

  ngOnInit() {
    this.campaignDetail = JSON.parse(localStorage.getItem('crown_collection'))

    // this.target.emit(true);
    this.getTargetDeatil()
  }

  getTargetDeatil() {
    this.apiService.getHeaders(this.apiConfig.getCrownTarget + `?campaign_id=${this.campaignDetail.campaign_id}&page_no=${this.page}`).subscribe((res: any) => {
      console.log(res)
      if (res.body.data.length != 0) {
        this.targetUserList = res.body.data.data
        this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')

        if (res.body.data.data.pagination.length != 0) {
          let crown_collection = {
            is_edit: this.campaignDetail.is_edit,
            create: this.campaignDetail.create,
            whitelist: this.campaignDetail.whitelist,
            points_config: this.campaignDetail.points_config,
            target: 1,
            campaign_id: this.campaignDetail.campaign_id
          }
          localStorage.setItem("crown_collection", JSON.stringify(crown_collection))
          this.target.emit(true);
        }
        this.excelData = res.body.data.data.data;
        for (var k in this.excelData[0]) {
          if (typeof this.excelData[k] !== 'function') {
            console.log("Key is " + k.replace(/_/g, ' '));
            this.excelFormat.header = k.replace(/_/g, ' ');
            this.excelFormat.key = k
            this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
            console.log(this.excelArray)
          }
        }

      }
    })
  }

  DownloadReportExcel() {
    console.log("here", this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('target', this.excelData, this.excelArray);
  }

  uploadExcel(id) {
    this.router.navigate(["/hubAdmin/crown-upload-excel/" + id])
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getTargetDeatil()
  }


  openUpdateRecord(update, data) {
    this.modalService.open(update, {
      centered: true,
      backdrop: "static",
    });

    this.formGroup = this.fb.group({
      id: new FormControl(data.id, []),
      points: new FormControl(data.target_qty, [Validators.required]),
      cap_min: new FormControl(data.cap_min, [Validators.required]),
      cap_max: new FormControl(data.cap_max, [Validators.required]),
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  submitted: boolean = false
  updateRecord(values: any) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return
    }
    console.log(values)
    let payload = {
      id: values.id,
      point: values.points,
      cap_min: values.cap_min,
      cap_max: values.cap_max
    }
    this.apiService.post(this.apiConfig.updateCrownTargets, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success(res.body.data)
      this.closeModal()
      this.getTargetDeatil()
    })
  }

  closeModal() {
    this.modalService.dismissAll()
    this.formGroup.reset()
  }

}
